import * as React from 'react';
import { FaGlobe, FaHome, FaEnvelope } from 'react-icons/fa';

import Link from "next/link";
import DOIImage from './DOI Foundation.svg';
import DOIDark from './DOI Dark.svg';
import ParLogo from './Pariveda.png';

function EidrLogo() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="385.72px"
      height="88.903px"
      viewBox="0 0 385.72 88.903"


    >
      <g>
        <path
          className="ercolors"
          d="M86.855,69.828c0,6.884,0,12.816,0,19.046
		c-29.021,0-57.742,0-86.855,0C0,59.388,0,30.179,0,0.588c28.907,0,57.633,0,86.758,0c0,6.114,0,12.172,0,18.838
		c-18.999,0-38.057,0-57.495,0l-0.042,16.247c18.144,0,36.051,0,54.278,0c0,6.248,0,11.967,0,18.234c-18.203,0-36.108,0-54.195,0
		l-0.161,15.921C48.349,69.828,67.398,69.828,86.855,69.828z"
        />
        <path
          className="inverse-blue"
          d="M213.522,69.934c14.109-0.056,20.686-5.86,22.817-19.758
		c0.642-4.18,0.483-8.279-0.227-12.412c-1.947-11.322-8.898-17.741-20.468-17.964c-15.644-0.302-53.284-0.018-53.284-0.018
		c0-6.067,0-12.974,0-18.996l68.588-0.097c20.843,1.387,32.58,13.358,35.286,33.952c1.281,9.744,0.965,19.262-1.802,28.634
		c-4.384,14.853-15.895,24.533-32.923,25.507h-69.15c0-5.932,0-13.27,0-19"
        />
        <path
          className="inverse-blue"
          d="M138.734,88.767c-9.675,0-18.765,0-28.302,0
		c0-29.393,0-58.454,0-88.077c9.31,0,18.642,0,28.302,0C138.734,29.979,138.734,59.047,138.734,88.767z"
        />
        <path
          className="ercolors"
          d="M381.694,68.619c-0.741-8.654-0.201-18.059-10.744-23.037
		c7.728-3.185,12.026-8.16,13.117-15.721c2.467-17.102-5.753-28.173-23.046-29.12c-24.787-1.358-49.756-0.467-74.576-0.374
		c-0.436,0.002-0.371,0.383-1.371,0.559c0,29.349,0,58.856,0,87.856c10,0,19.146,0,29.09,0c0-10,0.015-19.431,0.015-28.798
		c0,0,27.021-0.173,27.549-0.174c11.48-0.011,10.398,2.557,11.027,14.098c0.154,2.827,0.145,5.608,0.232,8.438
		c0.073,2.334,0.448,4.435,1.887,6.435c10.243,0,20.357,0,30.847,0C382.732,81.782,382.276,75.422,381.694,68.619z M342.779,39.596
		c-9.307,0.222-18.705,0.056-28.705,0.056c0-6.484,0-12.777,0-18.996l28.813-0.152c6.678,0.271,9.947,3.449,10.006,9.269
		C352.951,35.778,349.447,39.438,342.779,39.596z"
        />
        <rect
          x="162.074"
          y="35.782"
          className="inverse-blue"
          width="29"
          height="18"
        />
      </g>
    </svg>
  );
}

function ProfilePlaceholder() {
  return (
    <svg width={41} height={44} fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width={41} height={44} rx={20.5} fill="#fff" />
      <path
        d="M20.5 22c3.281 0 6-2.672 6-6 0-3.281-2.719-6-6-6-3.328 0-6 2.719-6 6 0 3.328 2.672 6 6 6Zm2.344 2.25h-4.735c-4.5 0-8.109 3.656-8.109 8.156 0 .89.703 1.594 1.594 1.594h17.765C30.25 34 31 33.297 31 32.406c0-4.5-3.656-8.156-8.156-8.156Z"
        fill="#000"
      />
    </svg>
  );
}

function Email() {
  return (
    <svg width={32} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29 0c1.625 0 3 1.375 3 3 0 1-.5 1.875-1.25 2.438L17.187 15.624c-.75.563-1.687.563-2.437 0L1.187 5.437C.438 4.875 0 4 0 3a3 3 0 0 1 3-3h26ZM13.562 17.25a4.031 4.031 0 0 0 4.813 0L32 7v13c0 2.25-1.813 4-4 4H4c-2.25 0-4-1.75-4-4V7l13.563 10.25Z"
        fill="#fff"
      />
    </svg>
  );
}

function Twitter() {
  return (
    <svg width={32} height={26} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.688 6.5v.875C28.688 16.063 22.125 26 10.063 26 6.313 26 2.875 24.937 0 23.062c.5.063 1 .125 1.563.125 3.062 0 5.875-1.062 8.124-2.812-2.874-.063-5.312-1.938-6.124-4.563.437.063.812.126 1.25.126.562 0 1.187-.126 1.687-.25-3-.626-5.25-3.25-5.25-6.438v-.063c.875.5 1.938.75 3 .813a6.457 6.457 0 0 1-2.938-5.438c0-1.25.313-2.375.875-3.312A19.04 19.04 0 0 0 15.75 8.125c-.125-.5-.188-1-.188-1.5A6.562 6.562 0 0 1 22.125.062c1.875 0 3.563.75 4.813 2.063A13.86 13.86 0 0 0 31.063.5c-.5 1.563-1.5 2.813-2.875 3.625a12.3 12.3 0 0 0 3.75-1c-.875 1.313-2 2.438-3.25 3.375Z"
        fill="#fff"
      />
    </svg>
  );
}

function LinkedInLogo() {
  return (
    <svg width={35} height={26} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.25 29H.437V10.312H6.25V29ZM3.312 7.812C1.5 7.813 0 6.25 0 4.376 0 1.812 2.75.187 5 1.5c1.063.563 1.688 1.688 1.688 2.875 0 1.875-1.5 3.438-3.375 3.438ZM27.938 29h-5.75v-9.063c0-2.187-.062-4.937-3.062-4.937s-3.438 2.313-3.438 4.75V29H9.875V10.312h5.563v2.563h.062c.813-1.438 2.688-3 5.5-3 5.875 0 7 3.875 7 8.875V29h-.063Z"
        fill="#fff"
      />
    </svg>
  );
}
function Home() {
  return (
    <div>
      <FaHome size={26} />
    </div>
  );
}
function Globe() {
  return (
    <Link href="/language">
      <FaGlobe size={26} />
    </Link>
  );
}
function E() {
  const handleClick = () => {
    // Set the subject line
    const subject = 'Web UI Support Question';

    // Encode the subject line for URL
    const encodedSubject = encodeURIComponent(subject);

    // Construct the mailto link with the encoded subject line
    const mailtoLink = `mailto:support@eidr.org?subject=${encodedSubject}`;

    // Open the mail client in a new tab/window with the pre-filled subject line
    window.open(mailtoLink, '_blank', 'noopener noreferrer');
  };

  return (
    <button type="button" onClick={handleClick} style={{ border: 'none', background: 'none', cursor: 'pointer' }}>
      <FaEnvelope size={26} />
    </button>
  );
}
function Slalom() {
  return (
    <div className="flex items-center ml-1">
      {/* Adding left margin here */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="45"
        height="57"
        fill="none"
        viewBox="0 0 216 57"
        style={{ marginLeft: '2.5rem' }}
      >
        <g fill="#000000" clipPath="url(#clip0_96_108)">
          <path d="M39.2 50.7c0 2.4 1.9 4.3 4.3 4.3h6.3V0H39.2v50.7zM82.4 19.9c-2.6-3.2-6.4-5.4-11.8-5.4-10.9 0-19.1 8.9-19.1 20.8s8.2 20.8 19.1 20.8c5.4 0 9.2-2.2 11.8-5.4v.1c0 2.4 1.9 4.3 4.3 4.3h6.1V15.6H82.4v4.3zm-9.8 26.3c-6.2 0-10.2-4.8-10.2-10.9 0-6 4-10.9 10.2-10.9 6.1 0 10.2 4.6 10.2 10.9 0 6.2-4.1 10.9-10.2 10.9zM95.6 50.7c0 2.4 1.9 4.3 4.3 4.3h6.3V0H95.6v50.7zM129.2 14.5c-12.3 0-21.3 8.9-21.3 20.8s9 20.8 21.3 20.8 21.4-8.9 21.4-20.8-9.1-20.8-21.4-20.8zm0 31.7c-6 0-10.5-4.5-10.5-10.9s4.5-10.9 10.5-10.9 10.5 4.5 10.5 10.9-4.5 10.9-10.5 10.9zM200.4 14.5c-5.2 0-10.3 1.8-13.4 6.8-2.6-4.2-7.3-6.8-13-6.8-4.5 0-8.8 1.5-11.6 5.7v-4.6h-10.3v35.2c0 2.4 1.9 4.3 4.3 4.3h6.3V33.4c0-5.9 3.8-8.9 8.4-8.9 4.8 0 7.7 3.1 7.7 8.8v17.4c0 2.4 1.9 4.3 4.3 4.3h6.3V33.4c0-5.9 3.8-8.9 8.4-8.9 4.8 0 7.7 3.1 7.7 8.8v17.4c0 2.4 1.9 4.3 4.3 4.3h6.3V29.9c-.1-9.2-6.4-15.4-15.7-15.4zM22.7 31l-4.8-.6c-3.6-.6-5.9-1.2-5.8-3.5 0-2.2 1.9-3.6 5.9-3.5 3.9.1 7.9 1.2 11 2.4 2.1.8 4.6-.1 5.5-2.2l2-4.3c-5.2-2.7-11.2-4.5-18.3-4.6-9.3-.3-17 4-17.2 12.2-.1 6.4 2.8 10.8 14.3 12.6l2.3.3c5.1.7 8.9.9 8.9 3.7-.1 2.9-3.1 3.9-9 3.8-6-.1-11.4-2.9-13.9-4.3L0 51.2c5.5 3.3 12.1 4.9 17.5 5 13.3.2 20-4.4 20.1-12.7.1-7.4-6.3-11.5-14.9-12.5z" />
        </g>
        <defs>
          <clipPath id="clip0_96_108">
            <path fill="#fff" d="M0 0H216V56.1H0z" />
          </clipPath>
        </defs>
      </svg>
      <span className="text-sm">Powered by Slalom Consulting</span>
    </div>
  );
}
function DOI() {
  return (
    <div className="flex items-center">
      <img src={DOIImage.src} className="w-auto doi-logo--light" alt="DOI Foundation" />
      <img src={DOIDark.src} className="w-auto doi-logo--dark" alt="DOI Foundation (dark)" />
    </div>
  );
}
function P() {
  return (
    <div>
      {/* P is short for Pariveda as there is no more room as of 4/9/24 e */}
      <img
        src={ParLogo.src}
        alt="Par logo"
        style={{
          width: '75px',
          height: '10px',
          marginTop: '0.25rem',
          marginRight: '0.25rem',
        }}
      />
    </div>
  );
}

export {
  EidrLogo, ProfilePlaceholder, Email, Twitter, LinkedInLogo, Slalom, Home, Globe, E, DOI, P,
};
